import {Model} from './Model';
import {City} from './City';
import {SessionStorageObject} from '../Utilities/SessionStorageObject';

interface StateTranslation {
  id: number;
  title: string;
  short: string;
  language: string;
  languageParent: number;
}

export class State extends Model implements SessionStorageObject {
  public title: string = '';
  public short: string = '';
  public countryId: number = 0;
  public translations: null | { [key: string]: StateTranslation } = null;
  public city: City | null = null;

  constructor(data: any) {
    super(data);

    this.title = data.title;
    this.short = data.short;
    this.countryId = data.countryId;
    this.translations = data.translations;
    if (data.city) {
      this.city = new City(data.city);
    }
  }

  fromStorage(data: any) {
    return new State(data);
  }
  toString(): string {
    return this.title;
  }
}
